import React, { Component } from "react";
import {Route} from 'react-router-dom';
import { Modal, ButtonGroup, Form } from "react-bootstrap";
import { getLevels } from "./../../apis/tutorList";
import { debounce } from "lodash";
import {
    DropdownButton,
    Dropdown,
    Spinner,
    Image,
  } from "react-bootstrap";
import SearchSubject from "./../../components/SearchSubject";

class FindATutor extends Component {
    constructor() {
        super();
        this.state = {
          toogle: false,
          subject: "",
          location: "",
          levels: [],
          errorMessage: "",
          levelValue: "",
          postCodeArray: [],
          searchmode: false,
          postcodeLoader: false,
          isOnlineORInp: false
        };
    }
    componentDidMount = () => {
        getLevels()
          .then((res) => {
            this.setState({ levels: res.data });
          })
          .catch((err) => {
            console.log(err, "err");
          });
      };
      
      getPostCode = debounce((text) => {
        this.setState({
          postcodeLoader: true,
        });
        let isInputFieldEmptyRE = /^\s*$/;
        if (!isInputFieldEmptyRE.test(text)) {
          fetch(`https://api.postcodes.io/postcodes/${text}/autocomplete`)
            .then((response) => {
              return response.json();
            })
            .then((response) => {
              if (response.status === 200) {
                this.setState({
                  postCodeArray: response.result,
                  searchmode: true,
                  postcodeLoader: false,
                });
              }
            })
            .catch((error) => {
              this.setState({
                postcodeLoader: false,
              });
            });
        } else {
          this.setState({
            searchmode: false,
            postcodeLoader: false,
            postCodeArray: [],
          });
        }
      }, 200);
    
      goTosearchTutor = () => {
        const { toogle, subject, location, levels, levelValue } = this.state;
        var regExpr = /^\s+$|^$/gi;
        if (
          (toogle ? !location.match(regExpr) : true) &&
          !levelValue.match(regExpr) &&
          !subject.match(regExpr)
        ) {
          this.setState({
            errorMessage: "",
            levelValue: "",
            location: "",
            subject: "",
          });

          this.props.onClose();
    
          this.props.history.push({
            pathname: "/tutors/search/",
            search: `?mode=${
              toogle === true ? "in-person" : "online"
            }&subject=${subject}&level=${levelValue}${
              toogle === true ? `&postCode=${location}` : ""
            }`,
          });
        } else {
          this.setState({
            errorMessage: "Please specify all the missing fields",
          });
        }
      };
      getSubjectValue = (value) => {
        let subAndLev = value.split("(");
        if (subAndLev.length > 1) {
          let subject = subAndLev[0].substring(0, subAndLev[0].length - 1);
          let level = subAndLev[1].substring(0, subAndLev[1].length - 1);
          this.setState({ subject: subject, levelValue: level, errorMessage: "" });
        } else {
          this.setState({ subject: value, levelValue: "", errorMessage: "" });
        }
      };
    render() {
        const {
            toogle,
            levels,
            levelValue,
            errorMessage,
            postCodeArray,
            searchmode,
            postcodeLoader,
            location,
            subject,
        } = this.state;
        const { findATutoropenModal, onClose } = this.props;
        return (
            <Modal
                className="FindATutor-modal"
                show={findATutoropenModal}
                onHide={onClose}
            >
                <Modal.Body>
                    <button
                            onClick={onClose}
                            type="button"
                            data-dismiss="modal"
                            aria-label="Close"
                            className="close"
                            >
                                <span className="x">x</span>
                    </button>
                    <ButtonGroup aria-label="Basic example" className="button-grp">
                        <button className={this.state.isOnlineORInp?"is-unselected-btn select-online-btn":"is-selected-btn select-online-btn"} onClick={() => {
                            this.setState({
                            toogle: false,
                            errorMessage: "",
                            isOnlineORInp: false
                            });
                        }}>Online</button>
                        <button className={!this.state.isOnlineORInp?"is-unselected-btn select-inperson-btn":"is-selected-btn select-inperson-btn"} onClick={() => {
                            this.setState({
                            toogle: true,
                            errorMessage: "",
                            isOnlineORInp: true
                            });}} >In-person
                        </button>
                    </ButtonGroup> 
                    <div className="row add-border m-0 p-0">
                      {toogle && (
                          <div className="col-lg-3 p-0">
                            <span
                            style={{ flex: toogle ? "1" : "2" }}
                          >
                          <Form.Control
                            type="text"
                            placeholder="Add your postcode"
                            onChange={(e) => {
                              this.getPostCode(e.target.value);
                              this.setState({ location: e.target.value });
                            }}
                            value={location}
                          />
                        <div
                          style={{
                            display:
                              postcodeLoader || (postCodeArray?.length && searchmode)
                                ? "flex"
                                : "none",
                          }}
                          className="postcode-list-div"
                        >
                    {!postcodeLoader ? (
                      searchmode && postCodeArray?.length ? (
                        postCodeArray.map((post, map) => (
                          <p
                            key={map}
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.setState({
                                location: post,
                                searchmode: false,
                                postCodeArray: [],
                              })
                            }
                          >
                            <div className="flex-start-center post-value">
                              <Image
                                style={{
                                  width: "15px",
                                  marginRight: "5px",
                                  marginBottom: "2px",
                                }}
                                src={require("./../../assets/icons/gps.png")}
                              />
                              <span>{post}</span>
                            </div>
                          </p>
                        ))
                      ) : (
                        "no post code"
                      )
                    ) : (
                    <div className="flex-center-center">
                      <Spinner
                        animation="border"
                        style={{ width: "25px", height: "25px" }}
                      />
                    </div>
                   )}
                  </div>
                </span>
                </div>
              )}
                      <div className={toogle?"col-lg-3 p-0":"col-lg-5 p-0"}>
                        <SearchSubject
                          placeholder={true}
                          subjectValue={subject}
                          getSubjectValue={(value) =>
                            this.getSubjectValue(value)
                          }
                        />
                      </div>
                      <div className={toogle?"col-lg-4 home-search-dropdown p-0":"col-lg-5 home-search-dropdown p-0"}>
                        <DropdownButton
                          id="dropdown-basic-button"
                          className="dropdown"
                          title={
                            <span className="flex-between-center">
                              <span className="search-date">
                                {levelValue ? levelValue : "Add level"}
                              </span>
                            </span>
                          }
                        >
                          {levels && levels.length ? (
                            levels.map((level, index) => {
                              return (
                                <Dropdown.Item
                                className="dropdown-item"
                                  onClick={() =>
                                    this.setState({
                                      levelValue: level,
                                      errorMessage: "",
                                    })
                                  }
                                  key={index}
                                >
                                  {level}
                                </Dropdown.Item>
                              );
                            })
                          ) : (
                            <Dropdown.Item className="dropdown-item">No Data</Dropdown.Item>
                          )}
                        </DropdownButton>
                    </div>
                  <div className="col-lg-2 p-0 search">
                    <button className="btn btn-success btn-success-size"  onClick={this.goTosearchTutor}><span className="fa fa-search"></span> Search</button>
                  </div>
                  <div className="col-12">
                  {errorMessage ? (
                <div className="flex-center-center error-message">
                  {errorMessage}
                </div>
                ) : null}
                  </div>
              </div>
            </Modal.Body>
          </Modal>
        );
    }
}
export default FindATutor;